<template>
  <DialogBase
    title="Thêm mới khối học"
    :visible.sync="dialogVisible"
    size="sm"
    panel-icon="el-icon-folder-add"
    panel-title="Thông tin khối"
    panel-subtitle="Nhập tên và mô tả cho khối học mới"
    :confirm-loading="loadingButton"
    :confirm-disabled="!showSaveChange"
    confirm-text="Lưu"
    confirm-type="primary"
    cancel-text="Hủy"
    cancel-type=""
    cancel-icon=""
    confirm-icon=""
    @before-close="handleClose"
    @cancel="handleClose"
    @confirm="handleSave"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="formRules"
      label-position="top"
    >
      <el-form-item label="Tên khối học" prop="gradeName">
        <el-input
          v-model="dataForm.gradeName"
          placeholder="Nhập tên khối"
          @keyup.enter.native="handleSave"
        />
        <span v-if="customErrorMessages.newName" class="sk-note sk-note--danger sk-u-mt-12">
          <i class="el-icon-warning-outline" />
          <span>{{ customErrorMessages.newName }}</span>
        </span>
      </el-form-item>
      <el-form-item label="Mô tả" prop="gradeDescription" class="sk-u-mt-12">
        <el-input
          v-model="dataForm.gradeDescription"
          type="textarea"
          :rows="1"
          autosize
          placeholder="Nhập mô tả"
        />
      </el-form-item>
    </el-form>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import GradeService from "@/services/GradeService";
import { mapActions, mapState } from "vuex";

export default {
  components: { DialogBase },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("gradeModule", ["getAllGradeInSchoolList", "gradeOfSchoolList"]),
  },
  data() {
    return {
      dataForm: {
        gradeName: "",
        gradeDescription: "",
      },
      customErrorMessages: {
        newName: "",
      },
      showSaveChange: false,
      loadingButton: false,
      formRules: {
        gradeName: [
          {
            validator: this.changeGradeName,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions("gradeModule", ["fetchDataGetAllGradeInSchoolList"]),

    handleClose(done) {
      this.showSaveChange = false;
      this.customErrorMessages.newName = "";
      this.$emit("dialog-close");
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.resetFields();
        }
      });
      if (typeof done === "function") done();
    },

    async changeGradeName(rule, value, callback) {
      if (this.getAllGradeInSchoolList.length !== 0) {
        for (let i = 0; i < this.getAllGradeInSchoolList.length; i++) {
          if (!value) {
            this.customErrorMessages.newName = "Giá trị không được để trống!";
            this.showSaveChange = false;
            break;
          } else if (
            value.toLowerCase().replace(/\s/g, "") ===
            this.getAllGradeInSchoolList[i].gradeName
              .toLowerCase()
              .replace(/\s/g, "")
          ) {
            this.customErrorMessages.newName =
              "Tên khối: " +
              this.getAllGradeInSchoolList[i].gradeName +
              " đã tồn tại!";
            this.showSaveChange = false;
            break;
          } else {
            this.showSaveChange = true;
            this.customErrorMessages.newName = "";
            await callback();
          }
        }
      } else {
        this.showSaveChange = true;
        this.customErrorMessages.newName = "";
        await callback();
      }
    },

    handleSave() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          GradeService.create(this.dataForm)
            .then((resp) => {
              this.fetchDataGetAllGradeInSchoolList();
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              this.handleClose();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.loadingButton = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";
</style>
